import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import { Capacitor } from '@capacitor/core';
import App from './App';
import './index.css';

// Polyfill Object.hasOwn for iOS Safari/WKWebView < 15.4 — react-markdown
// uses it and would otherwise throw on render in the chat UI, surfacing
// as "Romy hit an unexpected bump" via the ErrorBoundary.
if (!('hasOwn' in Object)) {
  (Object as any).hasOwn = (obj: object, key: PropertyKey) =>
    Object.prototype.hasOwnProperty.call(obj, key);
}

// Unregister service workers. On native they interfere with Capacitor's
// asset serving. On web we're shedding the old VitePWA-generated SW —
// /sw.js is now a kill-switch that does the same, but unregistering here
// shortens the migration window for users who hit the app before the
// browser's next SW update poll. The push-notification SW
// (firebase-messaging-sw.js) re-registers itself when needed.
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then((regs) => {
    regs.forEach((r) => {
      const url = r.active?.scriptURL || r.installing?.scriptURL || r.waiting?.scriptURL || '';
      if (Capacitor.isNativePlatform() || !url.includes('firebase-messaging-sw.js')) {
        r.unregister();
      }
    });
  }).catch(() => { /* ignore */ });
}

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.MODE,
  tracesSampleRate: 0.1,
  enabled: !!import.meta.env.VITE_SENTRY_DSN,
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

